import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const StackPercentageColumn = () => {

	//막대그래프
	const optionsBar = {
		chart: {
			type: 'column',
		},
		title: {
			text: '물동량',
			style: {
				color: '#000',
				fontSize: "14px",
				fontWeight: "bold",
			}
		},
		xAxis: {
			categories: ['2018/06', '2019/06', '2020/06', '2021/06']
		},
		yAxis: {
			min: 0,
			title: {
				text: '물동량'
			},
		},
		tooltip: {
			pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
			shared: true
		},
		plotOptions: {
			column: {
				stacking: 'percent'
			}
		},
		series: [{
			name: '가구/인테리어',
			data: [4, 4, 2, 4]
		}, {
			name: '도서/음반',
			data: [0, 4, 3, 2]
		}, {
			name: '디지털/가전',
			data: [1, 2, 2, 1]
		}],
		accessibility: {
			enabled: false
		},
	};

	return (
		<>
			<HighchartsReact highcharts={Hightcharts}
				options={optionsBar}
			/>
		</>
	);
};

export default StackPercentageColumn;